module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-oee-ui-mobile.pl-7e4d0d0e6428762ee8533092a79f41e8.png";